import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "questionFilled",
  "use": "questionFilled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"questionFilled\"><path d=\"M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 15.4c-.77 0-1.4-.63-1.4-1.4 0-.77.63-1.4 1.4-1.4.77 0 1.4.63 1.4 1.4 0 .77-.63 1.4-1.4 1.4zm1.55-5.06c-.48.22-.55.47-.55.76v.65h-2v-.96c0-.87.48-1.65 1.26-2.04l.4-.2c.21-.11.34-.32.34-.55 0-.55-.45-1-1-1s-1 .45-1 1H9c0-1.65 1.35-3 3-3s3 1.35 3 3c0 1-.55 1.9-1.45 2.34z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol